import React, { useState } from 'react';

const PaymentTest = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testFirebaseFunction = async () => {
    setLoading(true);
    setResult('Testing...');

    try {
      // Use local emulator for testing
      const functionUrl = 'http://127.0.0.1:5001/the-apn/us-central1/createCheckoutSession';
      const response = await fetch(functionUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: 'test-user-id',
          priceId: 'price_tier1_annual',
          tierKey: 'TIER1',
          discountCode: null,
          successUrl: `${window.location.origin}/membership/success`,
          cancelUrl: `${window.location.origin}/membership/cancel`
        }),
      });

      console.log('Response status:', response.status);
      console.log('Response headers:', response.headers);

      if (!response.ok) {
        const errorText = await response.text();
        setResult(`Error: ${response.status} - ${errorText}`);
        return;
      }

      const data = await response.json();
      setResult(`Success: ${JSON.stringify(data, null, 2)}`);
    } catch (error) {
      console.error('Test error:', error);
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Payment Function Test</h2>
      
      <button
        onClick={testFirebaseFunction}
        disabled={loading}
        className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 disabled:opacity-50"
      >
        {loading ? 'Testing...' : 'Test Firebase Function'}
      </button>

      {result && (
        <div className="mt-4 p-4 bg-gray-100 rounded">
          <h3 className="font-bold mb-2">Result:</h3>
          <pre className="whitespace-pre-wrap text-sm">{result}</pre>
        </div>
      )}
    </div>
  );
};

export default PaymentTest;
